export enum MetricAlertEditorTab {
	DEFINITION = 'DEFINITION',
	NOTIFICATIONS = 'NOTIFICATIONS',
	CASE_CREATION = 'CASE_CREATION'
}